import React from "react";

const EthIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity=".6"
      d="m6.41 7.6292-5.5872 2.541 5.5871 3.3009 5.585-3.3009-5.585-2.541Z"
      fill="currentColor"
    />
    <path
      opacity=".45"
      d="m.8228 10.1702 5.5871 3.3009V.9L.8228 10.1702Z"
      fill="currentColor"
    />
    <path
      opacity=".7"
      d="M6.4106.9V13.471l5.585-3.3009L6.4106.9Z"
      fill="currentColor"
    />
    <path
      opacity=".45"
      d="M.8228 11.2288 6.4099 19.1v-4.5703L.8228 11.2288Z"
      fill="currentColor"
    />
    <path
      opacity=".8"
      d="M6.4106 14.5297V19.1L12 11.2288l-5.5894 3.3009Z"
      fill="currentColor"
    />
  </svg>
);

export default EthIcon;
